import { Link } from "react-router-dom";
import { useSettings } from "@/context/AppContext";
import SEO from "@/components/SEO";
import { PageHero, Reveal } from "@/components/Motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ArrowUpRight } from "lucide-react";

export default function Faq() {
  const { settings } = useSettings();
  if (!settings) return <div className="min-h-screen bg-parchment" />;
  const seo = settings.seo?.pages?.faq;

  return (
    <div data-testid="faq-page">
      <SEO title={seo?.title} description={seo?.description} path="/faq" />
      <PageHero eyebrow="FAQ" title="Frequently asked questions." description="Answers about our products, minimum orders, packaging, samples, shipping and export documentation." />

      <section className="bg-parchment py-16 lg:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-8">
          <Reveal>
            <Accordion type="single" collapsible className="border border-forest/10 bg-white" data-testid="faq-accordion">
              {(settings.faqs || []).map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-forest/10 px-6" data-testid={`faq-item-${i + 1}`}>
                  <AccordionTrigger className="py-5 text-left font-serif text-lg text-forest hover:text-gold-dark hover:no-underline transition-colors">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-sm leading-relaxed text-[#4A554D]">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
          <Reveal className="mt-10 text-center">
            <p className="text-sm text-[#4A554D]">Have a question that isn't answered here?</p>
            <Link to="/contact" data-testid="faq-contact-cta" className="mt-4 inline-flex items-center gap-2 bg-forest px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.16em] text-parchment hover:bg-forest-leaf transition-colors">
              Contact Us <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
